module.exports = __webpack_public_path__ + "ab842a5d2c83dd74ad15ec4deec3b232.svg";